import { QueryClientProvider } from "@tanstack/react-query";
import { useEffect, type JSX } from "react";
import { RouterProvider } from "react-router";

import { queryClient } from "@/app/queryClient";
import { router } from "@/app/router";
import { useAuthStore } from "@/store/auth";

export function App(): JSX.Element {
  const restore = useAuthStore((state) => state.restore);

  // Exchange any stored token for the current user before the first route renders,
  // so a page refresh does not look like a logout.
  useEffect(() => {
    void restore();
  }, [restore]);

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
